// Import Bootstrap JS partials
// Source: https://getbootstrap.com/docs/4.0/getting-started/webpack/
// import 'bootstrap/js/dist/collapse';
// import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/modal';
// import 'bootstrap/js/dist/carousel';

// Import dependencies from node_modules
import 'jquery';


// Import partials
import MainSlider from './components/main-slider';
import OpinionsSlider from './components/opinions-slider';
import CooperationSlider from './components/cooperation-slider';
import BrandsSlider from './components/brands-slider';
import AboutSlider from './components/about-slider';
import OfferSlider from './components/offer-slider';
import Header from './components/header'
import Offer from './components/offer';
import ProjectsSlider from './components/projects-slider';
import MobileProjectsSlider from './components/mobile-projects-slider';
import FooterLocationsSlider from './components/footer-locations-slider';

import FooterAccordion from './components/footer-accordion';
import HamburgerMenu from './components/hamburger-menu';
import AboutReadMore from './components/read-more';
import Projects from './components/projects';
import Blog from './components/blog';
import Job from './components/job';

(($) => {
    new MainSlider();
    new OpinionsSlider();
    new CooperationSlider();
    new BrandsSlider();
    new AboutSlider();
    new OfferSlider();
    new Header();
    new ProjectsSlider();
    new MobileProjectsSlider();
    new FooterLocationsSlider();

    new FooterAccordion();
    new HamburgerMenu();
    new AboutReadMore();
    new Projects();
    new Blog();
    new Job();
    new Offer();
})(jQuery);
